import React from 'react';
import * as ReactDOM from 'react-dom/client';
import ReactDOMServer from 'react-dom/server';
import components from './components';

// biome-ignore lint/suspicious/noExplicitAny: State is typed as any from Adyen
type AnyState = any;

__webpack_nonce__ = document.currentScript?.nonce;

if (!__webpack_nonce__) {
  // biome-ignore lint/suspicious/noConsole: Allowed during error reporting
  console.warn(`⚠️ No nonce provided to webpack.`);
}

const tryHydrateReactComponents = () => {
  // Initialise React if there are any React components.
  if (!document.querySelector('react-component')) {
    return;
  }

  window.React = React;
  (window as AnyState).ReactDOM = ReactDOM;
  window.ReactDOMServer = ReactDOMServer;
  (global as AnyState).Components = components;

  if (
    'ReactJsAsyncInit' in window &&
    typeof window.ReactJsAsyncInit === 'function'
  ) {
    window.ReactJsAsyncInit();
  }
};

tryHydrateReactComponents();
